var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.02845 0.890147C1.71398 0.57568 1.20413 0.57568 0.889659 0.890147C0.575192 1.20461 0.575192 1.71447 0.889659 2.02893L8.86119 10.0005L0.889682 17.972C0.575215 18.2864 0.575215 18.7963 0.889682 19.1108C1.20415 19.4252 1.714 19.4252 2.02847 19.1108L9.99998 11.1392L17.9715 19.1107C18.2859 19.4252 18.7958 19.4252 19.1102 19.1107C19.4247 18.7963 19.4247 18.2864 19.1102 17.9719L11.1388 10.0005L19.1103 2.02895C19.4247 1.71449 19.4247 1.20463 19.1103 0.890167C18.7958 0.5757 18.286 0.5757 17.9715 0.890167L9.99998 8.86168L2.02845 0.890147Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0e72a79209229d7e5a35ff5a094a6cd5.svg";
export { ForwardRef as ReactComponent };